import { Props, IconContainerProps } from './Label.types';

export const getIconSize = (labelSize: Props['size']): IconContainerProps['size'] => {
  if (labelSize === 'lg') return 'lg';
  if (labelSize === 'xs') return 'sm';

  return 'md';
};
